'use strict';

var $    					= require('jquery');
var Core 					= require('../core/core.js');
var Velocity    	= require('velocity-animate');
var InspectorColorSwatchRow = require('./inspector__colorpicker__swatchrow.js');
var InspectorColorPickerMulticolor = require('./inspector__colorpicker__multicolor.js');

/**
 * Creates a color picker div. made to be used inside the inspector.
 * make sure to populate with color items
 *
 * @class
 */

class InspectorColorPicker extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
      <div class='editor__inspector__colorpicker js-inspector__colorpicker'>
				<div class='editor__inspector__modalbox__title'>Preset Swatches</div>
        <div class='editor__inspector__colorpicker__items js-inspector__colorpicker__items'></div>
      </div>
		`;

		super.render();

	}

  addDefaultColors() {
		var colors = ['#e9968c', '#fbc59a', '#f8e6b7', '#c8e4bd', '#b0e8ef', '#85cde6', '#aebeed', '#d3bfe5', '#efb1d4', '#e2c095', '#fafafa', '#a7adb1',
									'#e91d2d', '#f5831f', '#ffdd1a', '#46b749', '#75cedb', '#009fd7', '#3b55a3', '#7e3f98', '#d70b8c', '#d70b8c', '#dde2e4', '#61676a',
									'#951a21', '#e35b22', '#e1ad34', '#126936', '#1c505a', '#0076a9', '#192e62', '#492e72', '#901c53', '#603913', '#bfc7cc', '#2b2e31'];
		var row = null;
		for (var idx in colors) {
			if (idx%12 === 0) {
				row = this.addSwatchRow();
			}
			row.addColor(colors[idx]);
		}
  }

	addSwatchRow() {
		return new InspectorColorSwatchRow({
      target: $('.js-inspector__colorpicker__items', this.$el)
    });
	}

	addMulticolorOption() {
		return new InspectorColorPickerMulticolor({
			target: $('.js-inspector__colorpicker__items', this.$el)
		});
	}

	getColorSwatches() {
		return $('.js-inspector__colorswatch', this.$el);
	}

}
module.exports = InspectorColorPicker;
